import { render } from "./WebSocketComponent.vue?vue&type=template&id=6e3b8c53"
import script from "./WebSocketComponent.vue?vue&type=script&lang=js"
export * from "./WebSocketComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__